import {FieldValue} from '@coolcolduk/firebase-util';
import {FirestoreTimestamp} from '../_other/firestore/firestoreTimestampSchema';
import {ContactMessageDb} from './contactMessageDbSchema';
import {ContactMessageState} from './ContactMessageState';
import {ContactMessageWrite} from './contactMessageWriteSchema';

/**
 * Create a db schema from a write schema.
 * @param write - The write schema to create a db schema from.
 * @param createdAt - The created at timestamp using serverTimestamp()
 * @returns
 */
export function createContactMessageDb(
  write: ContactMessageWrite,
  createdAt: FirestoreTimestamp | FieldValue,
): ContactMessageDb {
  return {
    ...write,
    state: ContactMessageState.UNREAD,
    /** use date as no firebase package in model package */
    createdAt: createdAt as FirestoreTimestamp,
  };
}
